<script setup>
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import Button from 'primevue/button';
import { useCriarParecerParaEstudantesStore } from '@/store/criarParecerParaEstudantesStore';
const store = useCriarParecerParaEstudantesStore();
const { anoSelecionado, trimestresSelecionados, disciplinasDaArea, disciplinasSelecionadas, anoLetivo, estudantes} = storeToRefs(store);

const props = defineProps({
    turma: {
        type: Object,
        default: null
    },
    disciplinas: {
        type: Array,
        default: []
    },
    estudantes: {
        type: Array,
        default: []
    },
    anoLetivo: {
        type: Number,
        default: null
    }

})

anoSelecionado.value = props.turma.anoDoEnsinoMedio;
disciplinasDaArea.value = props.disciplinas;
estudantes.value = props.estudantes.map(estudante => estudante.users.id);
anoLetivo.value = props.anoLetivo;

const isDisabled = computed(() => {
    if (trimestresSelecionados.value.length == 1 && disciplinasSelecionadas.value.length === disciplinasDaArea.value.length) {
        return false;
    }

    return true;
});

</script>

<template>
    <Button label="Definir Pareceres" icon="pi pi-id-card" @click="store.carregarDados" :disabled="isDisabled" class="hidden lg:block" />
</template>
